import styled from "styled-components";

export const StyledInput = styled.input`
  width: 40px !important;
  height: 45px !important;
  border-radius: 9px !important;
  text-align: center !important;
  border: 1px solid ${(props) => (props.status === "error" ? "red" : "#D9D9D9")} !important;
  font-size: 17px !important;
  background: #D9D9D9;
  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  @media screen and (max-width: 380px) {
    width: 30px !important;
    height: 35px !important;
  }
  @media screen and (max-width: 320px) {
    width: 25px !important;
    height: 30px !important;
  }
`;

export const BottomBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
`;

export const BottomText = styled.div`
  cursor: pointer;
  color: #004F9C;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const TimeText = styled.div`
  color:  #13100F;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;


